
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-reqform',
  templateUrl: './reqform.component.html',
  styleUrls: ['./reqform.component.scss']
})
export class ReqformComponent implements OnInit {

  orgForm!: FormGroup;

  constructor(private fb: FormBuilder, private _ds: DataService) { }

  ngOnInit(): void {

    this.orgForm = this.fb.group({
      organizer_type: ['', Validators.required],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      organisation_name: ['', Validators.required],
      description: [''],          // conditional
      country: ['', Validators.required],
      city: ['', Validators.required],
      work_email: ['', [Validators.required, Validators.email]],
      country_code: ['+91', Validators.required],
      phone_number: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      website: ['', Validators.required],
      tickets_sold: ['', Validators.required],
      organizer_for: [''],        // conditional
      organizer_content: ['', Validators.required],

      // agree: [false, Validators.requiredTrue]
    });

    this.orgForm.get('organizer_type')?.valueChanges.subscribe(value => {

  if (value === 'Individual') {
    // REMOVE validation
    this.orgForm.get('description')?.clearValidators();
    this.orgForm.get('organizer_for')?.clearValidators();

    // RESET values
    this.orgForm.get('description')?.reset();
    this.orgForm.get('organizer_for')?.reset();
  } else {
    // ADD validation
    this.orgForm.get('description')?.setValidators(Validators.required);
    this.orgForm.get('organizer_for')?.setValidators(Validators.required);
  }

  this.orgForm.get('description')?.updateValueAndValidity();
  this.orgForm.get('organizer_for')?.updateValueAndValidity();
});


  }

  submitForm() {
    if (this.orgForm.valid) {

      const payload = {
        ...this.orgForm.value
      };

      console.log('Sending JSON:', payload);

      this._ds.submitReg(payload).subscribe({
        next: (res: any) => {
          console.log('Success:', res);
        },
        error: (err: any) => {
          console.error('Error:', err);
        }
      });

    } else {
      this.orgForm.markAllAsTouched();
    }
  }


}
